import styled from 'styled-components';
import { Sidebar, Image, Responsive } from 'semantic-ui-react';

export const WelcomeText = styled.p`
  font-size: 2em;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 1.8em;
    text-align: center;
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    font-size: 1.6em;
    text-align: center;
  }
`;

export const InfoText = styled.p`
  font-size: 1em;
  margin-bottom: 1em;

  @media (max-width: 768px) {
    font-size: 0.95em;
  }

  @media (max-width: 480px) {
    font-size: 0.9em;
  }
`;

export const Logo = styled(Image)`
  width: 12em;

  @media (max-width: 768px) {
    width: 10em;
    display: block;
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    width: 10em;
    display: block;
    margin: 0 auto;
  }

  @media (max-width: 375px) {
    width: 9em;
    display: block;
    margin: 0 auto;
  }
`;

export const Imag = styled(Image)`
  width: 8em;

  @media (max-width: 768px) {
    width: 6em;
  }

  @media (max-width: 480px) {
    width: 5em;
  }
`;

export const Confiax = styled.div`
  margin-top: 2em;
  text-align: center;
  display: flex;
  justify-content: center;

  @media (max-width: 480px) {
    margin-top: 1.5em;
  }
`;

export const Pushable = styled(Sidebar.Pushable)`
  height: 100vh !important;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  position: relative;

  @media (max-width: 768px) {
    overflow-y: auto !important;
  }
`;

export const FormContainer = styled.div`
  margin-top: 4em;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 2.5em;
  }

  @media (max-width: 480px) {
    margin-top: 2em;
  }

  /* Estilização moderna dos Inputs */
  .ui.input {
    width: 100%;
    margin-bottom: 0.5rem;
  }

  .ui.input > input {
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    background-color: #f8fafc !important;
    padding: 12px 14px !important;
    height: 48px !important;
    font-size: 16px !important;
    box-shadow: none !important;
    transition: all 0.2s ease;
  }

  .ui.input > input:focus {
    border-color: #59249B !important;
    background-color: #fff !important;
    box-shadow: 0 0 0 3px rgba(89, 36, 155, 0.1) !important;
  }

  /* Ajuste para ícones */
  .ui.input.left.icon > input {
    padding-left: 2.6em !important;
  }
  
  .ui.input > .icon {
    opacity: 0.6;
  }

  /* Estilização moderna dos Botões */
  .ui.button.login-button {
    width: 100%;
    margin-top: 0.5rem;
    border-radius: 8px !important;
    height: 50px !important;
    font-size: 1.1rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    
    background: #59249B !important; /* Cor sólida como base */
    background: linear-gradient(135deg, #59249B 0%, #7b3fe4 100%) !important; 
    color: white !important;
    border: none !important;
    box-shadow: 0 4px 6px -1px rgba(89, 36, 155, 0.2) !important;
    transition: transform 0.2s, box-shadow 0.2s !important;
  }

  .ui.button.login-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(89, 36, 155, 0.3) !important;
    filter: brightness(1.1);
  }

  .ui.button.login-button:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px -1px rgba(89, 36, 155, 0.2) !important;
  }
`;

export const SideBarGrid = styled(Responsive)`
  height: 100%;
  width: 30vw; /* Ocupa 30% da largura */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2em 4em;

  @media (max-width: 768px) {
    width: 100vw;
    padding: 2em 1.5em;
    justify-content: flex-start;
    padding-top: 3em;
  }

  @media (max-width: 480px) {
    padding: 1.5em 1em;
    padding-top: 2em;
  }

  @media (max-width: 375px) {
    padding: 1em 0.8em;
    padding-top: 1.5em;
  }
`;

export const Pusher = styled(Sidebar.Pusher)`
  flex: none; /* Remove o flex para que a imagem não mude de lugar */
  width: 70vw; /* Ocupa 70% da largura da tela */
  position: absolute; /* Faz a imagem ficar fixa à direita */
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  @media (max-width: 1024px) and (min-width: 769px) {
    width: 60vw; /* Ajusta para tablets em landscape */
  }

  @media (max-width: 768px) {
    display: none; /* Esconde a imagem no mobile */
  }
`;

export const ImageBackgroundCover = styled.div`
  position: absolute;
  height: 100vh;
  width: 100%;
  background-color: #0061ff;
  z-index: -1;
  opacity: 0.6;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ImageBackground = styled(Image)`
  height: 100vh; /* Ocupa toda a altura da tela */
  width: 100%; /* Faz a imagem ocupar 100% do container */
  object-fit: cover; /* Ajusta a imagem para cobrir o container */
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ImageBackgroundText = styled.div`
  font-size: 2em;
  line-height: 1.5em;
  color: white;
  width: 100%;
  text-align: center;
  margin-top: 1em;

  @media (max-width: 1024px) {
    font-size: 1.7em;
  }

  @media (max-width: 768px) {
    font-size: 1.5em;
  }

  @media (max-width: 480px) {
    font-size: 1.2em;
  }
`;
